// Card Sprite Layer: High-detail, edge wear, customizable backs
import * as PIXI from 'pixi.js';

export function createCardSprite(x: number, y: number, faceTexture: PIXI.Texture, backTexture: PIXI.Texture, faceUp: boolean = true, id: string = '') {
  const container = new PIXI.Container();
  const card = new PIXI.Sprite(faceUp ? faceTexture : backTexture);
  card.x = x;
  card.y = y;
  card.anchor.set(0.5);
  card.width = 84;
  card.height = 120;
  (container as any).label = id;
  // Edge wear effect (simple white border)
  const border = new PIXI.Graphics();
  border.roundRect(-36, -52, 72, 104, 10).stroke({ width: 2, color: 0xffffff, alpha: 0.18 });
  container.addChild(card, border);
  return container;
}
